import { render, staticRenderFns } from "./indexCategory(old).vue?vue&type=template&id=7f7277e4&scoped=true&"
import script from "./indexCategory(old).vue?vue&type=script&lang=js&"
export * from "./indexCategory(old).vue?vue&type=script&lang=js&"
import style0 from "./indexCategory(old).vue?vue&type=style&index=0&id=7f7277e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7277e4",
  null
  
)

export default component.exports